
import { computed, defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'SCheckbox',
  components: {},
  props: {
    indent: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup(props, { attrs, slots }) {
    const classes = computed(() => {
      let result = 's-checkbox ';

      result += `${props.indent ? 's-checkbox--indent' : ''} `;

      return result;
    });

    return { classes, slots };
  },
});
